<template>
  <div>
    <v-row class="d-flex">
      <v-col cols="3">
        <date-filter store="c2c"></date-filter>
      </v-col>
      <v-col cols="3">
        <site-group-filter store="c2c" />
      </v-col>

      <v-col cols="6" class="d-flex">
        <v-spacer />
        <apply-filters :disabled="isLoading" outlined color="secondary" />
      </v-col>
      <v-col cols="12">
        <site-filter store="c2c" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import useAxios from "@/hooks/useAxios";

import ApplyFilters from "@/components/common/filters/ApplyFilters.vue";
import DateFilter from "@/components/common/filters/DateFilter";
import SiteFilter from "@/components/common/filters/SiteFilter";
import SiteGroupFilter from "@/components/common/filters/SiteGroupFilter";

export default {
  name: "Filters",
  components: {
    ApplyFilters,
    DateFilter,
    SiteFilter,
    SiteGroupFilter,
  },
  data() {
    return {};
  },
  setup() {
    const { isLoading } = useAxios();

    return {
      isLoading,
    };
  },
};
</script>

<style></style>
